export const ArticleHeaderDotSeparator = () => <div className="h-[3px] w-[3px] bg-gray-400 rounded-full" />;
